<template>
  <b-container fluid>
    <b-row class="my-3">
      <b-col class="d-flex">
        <a-month-picker v-model="dateValue"
                        @change="changeYear"
                        format="MM/YYYY"
                        placeholder="Выберите дату"
                        name="input"
                        class="statistic mx-3"/>
        <b-button class="b-report mx-3"
                  variant="success"
                  @click="setItems"
                  :disabled="disableButton"
                  type="button">Загрузить отчет
        </b-button>
      </b-col>
    </b-row>
    <b-row v-if="salesStatistic">
      <b-col md="4" lg="3">
        <b-form-select v-model="filterOptions.selectedDealer"
                       :options="salesStatistic"
                       value-field="id"
                       text-field="name"
                       @input="filterDealers"
                       class="m-3"
        >
          <option :value="null" v-if="salesStatistic.length > 1">Все дилеры</option>
        </b-form-select>
      </b-col>
      <b-col md="5" lg="4">
        <div class="search m-3">
          <b-form-input v-model="filterOptions.searchFilter" @input="searchItemsInTable" placeholder="Поиск"/>
          <div class="container_search-close"
               @click="clearField">
            <span class="search-close">&#215;</span>
          </div>
        </div>
      </b-col>
      <b-col md="3" lg="5" class="button-end">
        <b-button v-if="isActiveClientWithoutCtmId()" @click="downloadActiveClientsWithoutCtmIdReport" variant="outline-success" class="m-3">
          <b-spinner v-if="visible" small type="grow" class="mr-3"></b-spinner>Активные клиенты без CTM_ID
        </b-button>
        <b-button v-if="dealerId===53" @click="downloadXml" variant="outline-success" class="m-3">Выгрузить в XML
        </b-button>
        <b-dropdown v-if="isProminvestUser()" right variant="success" class="m-3">
          <template v-slot:button-content>
            Отчёт для КП
          </template>
          <b-dropdown-item v-for="dealer in salesStatistic"
                           @click="downloadXlsxClientProgram(dealer.id, dealer.name)"
                           :key="dealer.id">
            <p class="mb-0 download-report">{{dealer.name}} <i class="fas fa-file-download"></i></p>
          </b-dropdown-item>
        </b-dropdown>
        <b-dropdown right variant="success" class="m-3">
          <template v-slot:button-content>
            Выгрузить в Excel
          </template>
          <b-dropdown-item v-for="dealer in salesStatistic"
                           @click="downloadXlsx(dealer.id, dealer.name)"
                           :key="dealer.id">
            <p class="mb-0 download-report">{{dealer.name}} <i class="fas fa-file-download"></i></p>
          </b-dropdown-item>
        </b-dropdown>
      </b-col>
    </b-row>
    <b-row v-if="salesStatistic">
      <b-col>
        <b-card bg-variant="light" class="m-3">
          <b-row>
            <b-col>
              <p class="info-text">Всего пакетов:</p>
              <p class="total">{{totalPackagesValue}}
                <b-button id="popover-1" size="sm" variant="light" v-if="this.filterOptions.selectedDealer!==null"><i
                  class="fas fa-caret-down"></i></b-button>
              </p>
            </b-col>
            <b-col><p class="info-text">Всего активных клиентов:</p>
              <p class="total">{{totalActiveClientsValue}}</p></b-col>
            <b-col><p class="info-text">Итого к уплате клиентами:</p>
              <p class="total">{{totalCostValue}} руб.</p></b-col>
            <b-col v-if="totalUpdealerCostValue"><p class="info-text">Итого к уплате Проминвест:</p>
              <p class="total">{{totalUpdealerCostValue}} руб.</p></b-col>
            <b-col v-if="totalCTMCostValue"><p class="info-text">Итого к уплате СТМ:</p>
              <p class="total">{{totalCTMCostValue}} руб.</p></b-col>
            <b-popover
              v-if="this.filterOptions.selectedDealer!==null"
              target="popover-1"
              placement="bottom"
              triggers="click"
            >
              <ul class="w-100">
                <li class="positions-elements"
                    v-for="position in totalPackagesTable"
                    :key="position.count"
                >
                  {{position.name}} - {{position.count}}
                </li>
              </ul>
            </b-popover>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row v-if="salesStatistic">
      <b-col class="ml-3">
        <small><p>Отфильтровано записей {{dealerItems.length}} из {{salesStatisticClients.length}}</p></small>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <span v-if="dealerItems">
        <b-table-simple hover small bordered responsive id="myTable" class="p-3">
          <b-thead>
            <b-tr>
              <b-th v-for="field in dealerFields" :key="field.key">{{field.label}}</b-th>
            </b-tr>
          </b-thead>
          <b-tbody v-for="(client, index) in dealerItems" :key="index">
            <b-tr v-for="(position, index) in client.positions" :key="index">
              <b-td :rowspan="client.positions.length" v-if="index===0">
                <p class="mb-0"><b>{{client.name}}</b></p>
                <small><p class="mb-1">{{client.inn}} / {{client.kpp}}</p></small>
                <small v-if="client.contract_number&&client.contract_date"><p class="mb-1">{{client.contract_number}} /
                  {{client.contract_date}}</p></small>
              </b-td>
              <b-td>{{position.name}}</b-td>
              <b-td>{{position.count}}</b-td>
              <b-td>{{position.cost}}</b-td>
              <b-td>{{position.ctm_cost}}</b-td>
              <b-td>{{position.comment}}</b-td>
            </b-tr>
            <tr>
              <td colspan="3" class="total text-right"><b>Итого&nbsp;:</b></td>
              <td><b>{{client.total_cost}}</b></td>
              <td><b>{{client.ctm_cost}}</b></td>
              <td></td>
            </tr>
          </b-tbody>
        </b-table-simple>
          </span>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'statistic',
  data () {
    return {
      loading: false,
      dealerFields: [
        { key: 'organization', label: 'Организация' },
        { key: 'service', label: 'Услуги' },
        { key: 'quantity', label: 'Кол-во' },
        { key: 'amount', label: 'Сумма' },
        { key: 'ctm', label: 'СТМ' },
        { key: 'comments', label: 'Комментарий' }
      ],
      dealerItems: null,
      dateValue: null,
      dateForReport: null,
      dateString: null,
      filterOptions: {
        searchFilter: null,
        selectedDealer: null
      },
      totalPackagesValue: null,
      totalActiveClientsValue: null,
      totalCostValue: null,
      totalCTMCostValue: null,
      totalUpdealerCostValue: null,
      totalPackagesTable: null,
      disableButton: true,
      selectedMonth: null,
      selectedYear: null
    }
  },
  watch: {
    salesStatisticClients () {
      this.dealerItems = JSON.parse(JSON.stringify(this.salesStatisticClients))
    },
    filterOptions: {
      handler: function () {
        this.dealerItems = this.salesStatisticClients.filter(item => {
          return this.searchItemsInTable(item) && this.filterDealers(item)
        })
      },
      deep: true
    },
    'filterOptions.selectedDealer' () {
      if (this.filterOptions.selectedDealer !== null) {
        const dealer = this.salesStatistic.find(elm => elm.id === this.filterOptions.selectedDealer)
        this.totalPackagesValue = dealer.total_packages
        this.totalPackagesTable = dealer.positions
        this.totalCostValue = dealer.total_cost
        this.totalCTMCostValue = dealer.ctm_cost
        this.totalUpdealerCostValue = dealer.updealer_cost
        this.totalActiveClientsValue = dealer.clients.length
      } else {
        this.totalPackagesValue = this.totalPackages
        this.totalCostValue = this.totalCost
        this.totalCTMCostValue = this.totalCTMCost
        this.totalUpdealerCostValue = this.totalUpdealerCost
        this.totalActiveClientsValue = this.totalActiveClients
      }
    },
    salesStatistic () {
      if (this.salesStatistic && this.salesStatistic.length === 1) {
        this.filterOptions.selectedDealer = this.salesStatistic[0].id
      }
    },
    totalPackages () {
      this.totalPackagesValue = this.totalPackages
    },
    totalCost () {
      this.totalCostValue = this.totalCost
    },
    totalCTMCost () {
      this.totalCTMCostValue = this.totalCTMCost
    },
    totalUpdealerCost () {
      this.totalUpdealerCostValue = this.totalUpdealerCost
    },
    totalActiveClients () {
      this.totalActiveClientsValue = this.totalActiveClients
    },
    dateValue: {
      handler: function () {
        if (this.dateValue !== null) {
          this.disableButton = false
        }
      },
      deep: true
    }
  },
  beforeDestroy () {
    this.clearStatistic()
  },
  computed: {
    ...mapState(
      {
        salesStatisticClients: state => state.statistic.salesStatisticClients,
        salesStatistic: state => state.statistic.salesStatistic,
        totalPackages: state => state.statistic.totalPackages,
        totalCost: state => state.statistic.totalCost,
        totalCTMCost: state => state.statistic.totalCTMCost,
        totalUpdealerCost: state => state.statistic.totalUpdealerCost,
        totalActiveClients: state => state.statistic.totalActiveClients,
        dealerId: state => state.authorization.userInfo.company.company_profile.ctm_id,
        userInfo: state => state.authorization.userInfo,
        visible: state => state.statistic.visible
      }
    )
  },
  methods: {
    downloadActiveClientsWithoutCtmIdReport () {
      this.getActiveClientsWithoutCtmIdReport({ month: this.selectedMonth, year: this.selectedYear })
    },
    isActiveClientWithoutCtmId () {
      const hasRights = this.userInfo.rights.user.filter(item => {
        return item === 'report_active_clients_without_ctmid'
      })
      return (hasRights.length > 0)
    },
    isProminvestUser () {
      const hasRights = this.userInfo.rights.user.filter(item => {
        return item === 'prominvest_report'
      })
      return (hasRights.length > 0)
    },
    setItems () {
      this.clearStatistic()
      this.loading = true
      this.loadSalesStatistic(this.dateForReport)
        .then(() => {
          this.loading = false
        })
      this.disableButton = true
      this.filterOptions.selectedDealer = null
    },
    searchItemsInTable (elm) {
      if (this.filterOptions.searchFilter !== null) {
        return JSON.stringify(elm).toUpperCase().indexOf(this.filterOptions.searchFilter.toUpperCase()) > -1
      } else {
        return this.salesStatisticClients
      }
    },
    filterDealers (elm) {
      if (this.filterOptions.selectedDealer !== null) {
        return elm.dealer_id === this.filterOptions.selectedDealer
      } else {
        return this.salesStatisticClients
      }
    },
    clearField () {
      this.filterOptions.searchFilter = null
    },
    downloadXlsxClientProgram (id, name) {
      this.loadDealerReportProminvestXlsx({
        date: this.dateForReport,
        dateString: this.dateString,
        dealerId: id,
        dealerName: name
      })
    },
    downloadXlsx (id, name) {
      this.loadDealerReportXlsx({
        date: this.dateForReport,
        dateString: this.dateString,
        dealerId: id,
        dealerName: name
      })
    },
    downloadXml () {
      this.loadDealerReportXml(this.dateForReport)
    },
    changeYear (date, dateString) {
      const monthYear = dateString.split('/').map((elm) => {
        return +elm
      })
      this.dateString = dateString
      this.dateForReport = monthYear[1] * 12 + monthYear[0]
      this.selectedMonth = monthYear[0]
      this.selectedYear = monthYear[1]
    },
    ...mapActions('statistic',
      [
        'loadDealerReportXlsx',
        'loadSalesStatistic',
        'loadDealerReportXml',
        'loadDealerReportProminvestXlsx',
        'getActiveClientsWithoutCtmIdReport'
      ]
    ),
    ...mapMutations('statistic',
      [
        'clearStatistic'
      ]
    )
  }
}
</script>

<style scoped lang="scss">
  .table thead th {
    min-width: 80px;
  }

  select {
    cursor: pointer;
  }

  .button-end {
    display: flex;
    justify-content: flex-end;
  }

  .download-report {
    display: flex;
    justify-content: space-between;
    align-items: center;
    i {
      color: #6c6c6c;
    }
  }

  ul {
    margin-bottom: 0;
    padding-left: 0;
    li.positions-elements {
      list-style: none;
      border-bottom: 1px solid #dadada;
      padding: 10px;
    }
  }

  p.total {
    font-weight: 400;
    font-size: 18px;
    color: #6c6c6c;
    margin-bottom: 0;
  }

  p.info-text {
    font-size: 14px;
    margin-bottom: 0;
  }

  .container_search-close {
    position: absolute;
    right: 35px;
    top: 21px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    z-index: 4;
    &:hover {
      border-radius: 50%;
      background-color: #acacac;
    }
    .search-close {
      font-size: 18px;
      color: #acacac;
      cursor: pointer;
      line-height: 18px;
      width: 20px;
      text-align: center;
      margin-bottom: 2px;
      &:hover {
        color: #fff;
      }
    }
  }
  @media screen and (max-width: 1024px) {
    p.info-text {
      font-size: 12px;
      margin-bottom: 0;
    }
  }
</style>
